import React from 'react';
import { Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import useCampaignPills from '@/hooks/useCampaignPills';
import { isNotNilOrEmpty } from '@/lib/object';
import Flight from '@/propTypes/Flight';
import getCampaignCodeFromSegments from '@/utils/campaigns/getCampaignCodeFromSegments';

const PillSpacer = ({ segments }) => {
  const { campaignPills } = useCampaignPills();
  return (
    isNotNilOrEmpty(getCampaignCodeFromSegments(segments, campaignPills)) && (
      <Box data-testid="PILL-SPACER" mt={[4, null, 6]} />
    )
  );
};

PillSpacer.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape(Flight)),
};

export default PillSpacer;
